import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CONFIG } from '../config/variables';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiActivity } = FiIcons;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/#' + sectionId);
      setIsMobileMenuOpen(false);
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Overview', id: 'hero' },
    { label: 'Proof', id: 'proof' },
    { label: 'Our Work', id: 'samples' },
    { label: 'Investment', id: 'investment' },
    { label: 'FAQ', id: 'faq' }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 w-full h-16 sm:h-20 z-50 transition-all duration-300 ${isScrolled || location.pathname !== '/' ? 'bg-black/80 backdrop-blur-lg border-b border-slate-700/50' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 lg:h-20">
          <Link to="/" className="flex items-center whitespace-nowrap">
            {CONFIG.LOGO_URL !== "TOBEUPDATED" ? (
              <img src={CONFIG.LOGO_URL} alt={`${CONFIG.BUSINESS_NAME} logo`} className="h-7 sm:h-9 w-auto" />
            ) : (
              <div className="text-white font-black text-sm sm:text-base leading-none tracking-tighter italic">
                BPA <span className="text-blue-500">TRADE</span>
              </div>
            )}
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-slate-300 hover:text-white transition-colors duration-200 font-semibold text-sm"
              >
                {item.label}
              </button>
            ))}
            {CONFIG.PREVIEW_MODE && (
              <Link to="/onboarding" className="flex items-center gap-2 text-yellow-500 hover:text-yellow-400 font-bold text-xs uppercase tracking-widest border border-yellow-500/30 px-3 py-1.5 rounded-lg bg-yellow-500/5">
                <SafeIcon icon={FiActivity} />
                Admin: Open Onboarding
              </Link>
            )}
          </nav>

          <div className="hidden lg:block">
            <button
              onClick={() => scrollToSection('payment')}
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2.5 rounded-xl font-bold hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg"
            >
              Request Plan
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-slate-300 p-2"
          >
            <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-slate-700/50 absolute top-full left-0 w-full py-8 px-4 flex flex-col gap-6 text-center transition-all duration-200 ease-out">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-white text-lg font-bold"
              >
                {item.label}
              </button>
            ))}
            {CONFIG.PREVIEW_MODE && (
              <Link
                to="/onboarding"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-yellow-500 font-bold uppercase tracking-widest py-2"
              >
                Admin: Onboarding
              </Link>
            )}
            <button
              onClick={() => scrollToSection('payment')}
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-4 rounded-xl font-bold"
            >
              Request Plan
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;